module.exports = __webpack_public_path__ + "img/2-settings.b18f687e.svg";